module.exports = __webpack_public_path__ + "static/img/logo.42e64181.png";